export default "__VITE_ASSET__9$Vz0pqE__"